export default __webpack_public_path__ + "static/media/hero-video-mobile-safari-pt.dac91c7b.mp4";